import React, { act, useEffect, useMemo, useState } from 'react';
import { arrayRemove, arrayUnion, collection, doc, onSnapshot, setDoc, updateDoc } from 'firebase/firestore';
import { db } from '../firebase';
import ArrowBack from '../components/arrowBack';

export default function BookInfoPanel() {

  const [facilities, setFacilities] = useState([])
  const [locations, setLocations] = useState("")

  const [facility, setFacility] = useState("")
  const [location, setLocation] = useState("")
  const [groups, setGroups] = useState("")

  const [selectedGroup, setSelectedGroup] = useState("")
  const [list, setList] = useState("")

  const [newUser, setNewUser] = useState("")
  const [user, setUser] = useState("")
  const [confDel, setConfDel] = useState("")

  const [userList, setUserList] = useState("")   // globalna lista unikalnych osób
  const [bookMark, setBookMark] = useState(0)   // 0 – menu główne, 1 – lista uczestników (global)
                                                // 2 – wydarzenia specjalne (nowe)
  const [locCount, setLocCount] = useState({ total: 0, registered: 0 });

  // global counters i search
  const [globalCount, setGlobalCount] = useState({ total: 0, registered: 0 });
  const [searchQuery, setSearchQuery] = useState("");

  // Normalizacje
  const normalizeName = (s = "") => s.toString().trim().replace(/\s+/g, " ").toLowerCase();
  const normalizeEmail = (s = "") => s.toString().trim().toLowerCase();
  const normalizePhone = (s = "") => s.toString().replace(/\D+/g, "");

  const TARGET_FACILITY = "0veHsVHiLqauiEYVpeexW";

  // ID wszystkich grup należących do wybranej placówki
  const [facilityGroupIds, setFacilityGroupIds] = useState([]);
  const [facilityGroupsMap, setFacilityGroupsMap] = useState({}); // idGrupy -> obiekt
  const [locMap, setLocMap] = useState({}); // idLokalizacji -> obiekt

  useEffect(() => {
    const unsub = onSnapshot(doc(db, "groups", TARGET_FACILITY), (snap) => {
      const data = snap.data() || {};
      setFacilityGroupIds(Object.keys(data));
      setFacilityGroupsMap(data);
    });
    return () => unsub();
  }, []);

useEffect(() => {
  const getFacilities = onSnapshot(collection(db, "facilities"), (snapshot) => {
    setFacilities(
      snapshot.docs.map((d) => ({
        id: d.id,
        ...d.data(),
      }))
    );
  });

  return () => getFacilities();
}, []);

  useEffect(() => {
    if (!facility) return
    const getLocations = onSnapshot(doc(db, "locations", facility?.id), (snapshot) => {
      setLocations(snapshot.data());
    });
  }, [facility]);

  useEffect(() => {
    const unsub = onSnapshot(doc(db, "locations", TARGET_FACILITY), (snap) => {
      const raw = snap.data() || {};
      const map = {};
      Object.values(raw).forEach((l) => { if (l?.id) map[l.id] = l; });
      setLocMap(map);
    });
    return () => unsub();
  }, []);

  useEffect(() => {
    if (selectedGroup === "") return
    const getList = onSnapshot(doc(db, "book-list", selectedGroup?.id), (snapshot) => {
      setList(snapshot.data());
    });
  }, [selectedGroup]);

  // ====== GLOBAL: zbieranie unikalnych osób z book-list dla całej placówki ======
  useEffect(() => {
    if (bookMark !== 1) return;

    const unsub = onSnapshot(collection(db, "book-list"), (snapshot) => {
      const idSet = new Set(facilityGroupIds);

      const all = [];
      snapshot.docs.forEach((d) => {
        if (!idSet.has(d.id)) return;
        const users = d.data()?.users || [];
        users.forEach((u) => all.push({ ...u, _groupId: d.id }));
      });

      // deduplikacja po (name+phone) jeśli oba są
      const normalizeName  = (s = "") => s.trim().replace(/\s+/g, " ").toLowerCase();
      const normalizePhone = (s = "") => s.toString().replace(/\D+/g, "");

      const map = new Map();
      all.forEach((u, idx) => {
        const n = normalizeName(u?.displayName);
        const p = normalizePhone(u?.phone);
        const canMerge = !!n && !!p;
        const key = canMerge ? `${n}|${p}` : `__noMerge__${idx}_${u?._groupId || "g"}`;

        if (!map.has(key)) {
          map.set(key, {
            displayName: u?.displayName || "",
            phone: u?.phone || "",
            mail: u?.mail || "",
            age: u?.age || "",
            info: u?.info || "",
            registeredAny: !!u?.registered,
            _occurrences: 1,
            _groups: [u?._groupId],
            _canBeDuplicate: canMerge,
          });
        } else {
          const r = map.get(key);
          r._occurrences += 1;
          r._groups.push(u?._groupId);
          r.registeredAny = r.registeredAny || !!u?.registered;

          if (!r.phone && u?.phone) r.phone = u.phone;
          if (!r.mail && u?.mail) r.mail = u.mail;
          if (!r.displayName && u?.displayName) r.displayName = u.displayName;
          if (!r.age && u?.age) r.age = u.age;
          if (!r.info && u?.info) r.info = u.info;
        }
      });

      const unique = Array.from(map.values());
      setUserList(unique);
      setGlobalCount({
        total: unique.length,
        registered: unique.filter((x) => x.registeredAny).length,
      });
    });

    return () => unsub();
  }, [bookMark, facilityGroupIds]);

  // statystyka lokalizacji – z deduplikacją po nazwie
  useEffect(() => {
    if (location) {
      const getGroups = onSnapshot(doc(db, 'groups', facility?.id), (snapshot) => {
        const data = snapshot.data();

        let transformedGroups = [];

        Object.keys(data).forEach((groupId) => {
          const group = data[groupId];

          if (group.days.length > 1 && !group.rnieozdzielenia) {
            group.days.forEach((day) => {
              const newGroup = {
                ...group,
                days: day,
              };
              transformedGroups.push(newGroup);
            });
          } else {
            const newGroup = {
              ...group,
              days: group.days[0],
            };
            transformedGroups.push(newGroup);
          }
        });

        setGroups(transformedGroups);
      });
    }
  }, [location]);

  const [error, setError] = useState("")

  const dayAbbr = (d) => {
    const full = weekDayConvert(d) || "";
    return full.slice(0, 3);
  };

  const addUser = () => {
    if (!newUser?.displayName || !newUser?.mail || !newUser?.phone) {
      setError("Nie podano wszystkich danych")
      return
    }

    setDoc(doc(db, "book-list", selectedGroup?.id), {
      users: arrayUnion({
        displayName: newUser?.displayName,
        phone: newUser?.phone,
        mail: newUser?.mail,
        age: newUser?.age ? newUser?.age : "",
        info: newUser?.info ? newUser?.info : "",
        registered: false
      })
    }, { merge: true })

    setNewUser("")
  }

  // statystyka lokalizacji na żywo
  useEffect(() => {
    if (!location) return;
    const unsub = onSnapshot(doc(db, 'groups', facility?.id), (snapshot) => {
      const data = snapshot.data() || {};
      const transformed = [];

      Object.keys(data).forEach((groupId) => {
        const group = data[groupId];
        if (!group) return;
        if (Array.isArray(group.days) && group.days.length > 1 && !group.rnieozdzielenia) {
          group.days.forEach((day) => transformed.push({ ...group, id: groupId, days: day }));
        } else {
          transformed.push({
            ...group,
            id: groupId,
            days: Array.isArray(group.days) ? group.days[0] : group.days,
          });
        }
      });

      setGroups(transformed);
    });
    return () => unsub();
  }, [location, facility]);

  useEffect(() => {
    if (!location || !groups?.length) {
      setLocCount({ total: 0, registered: 0 });
      return;
    }

    const idsInLocation = new Set(
      groups
        .filter(g => g?.location_id === location?.id)
        .map(g => g?.id)
        .filter(Boolean)
    );

    const unsub = onSnapshot(collection(db, "book-list"), (snapshot) => {
      const allNames = new Set();
      const regNames = new Set();

      const normalize = (s = "") =>
        s.toString().trim().replace(/\s+/g, " ").toLowerCase();

      snapshot.docs.forEach(docSnap => {
        if (!idsInLocation.has(docSnap.id)) return;
        const users = docSnap.data()?.users || [];
        users.forEach(u => {
          const key = normalize(u?.displayName || "");
          if (!key) return;
          allNames.add(key);
          if (u?.registered) regNames.add(key);
        });
      });

      setLocCount({ total: allNames.size, registered: regNames.size });
    });

    return () => unsub();
  }, [location, groups]);

  const editUser = () => {
    if (!user?.displayName === "" || !user?.mail === "" || !user?.phone === "") {
      setError("Nie można usunąć podstawowych danych")
      return
    }

    updateDoc(doc(db, "book-list", selectedGroup?.id), {
      users: arrayRemove({
        displayName: user?.displayName,
        phone: user?.phone,
        mail: user?.mail,
        age: user?.age,
        info: user?.info,
        registered: user?.registered
      }),
    }, { merge: true })

    updateDoc(doc(db, "book-list", selectedGroup?.id), {
      users: arrayUnion({
        displayName: user?.new_displayName ? user?.new_displayName : user?.displayName,
        phone: user?.new_phone ? user?.new_phone : user?.phone,
        mail: user?.new_mail ? user?.new_mail : user?.mail,
        age: user?.new_age ? user?.new_age : user?.age,
        info: user?.new_info ? user?.new_info : user?.info,
        registered: user?.registered,
      }),
    }, { merge: true })

    setUser("")
  }

  const confirmUser = () => {
    updateDoc(doc(db, "book-list", selectedGroup?.id), {
      users: arrayRemove({
        displayName: user?.displayName,
        phone: user?.phone,
        mail: user?.mail,
        age: user?.age,
        info: user?.info,
        registered: user?.registered
      }),
    }, { merge: true })

    updateDoc(doc(db, "book-list", selectedGroup?.id), {
      users: arrayUnion({
        displayName: user?.new_displayName ? user?.new_displayName : user?.displayName,
        phone: user?.new_phone ? user?.new_phone : user?.phone,
        mail: user?.new_mail ? user?.new_mail : user?.mail,
        age: user?.new_age ? user?.new_age : user?.age,
        info: user?.new_info ? user?.new_info : user?.info,
        registered: user?.registered ? false : true,
      }),
    }, { merge: true })

    setUser("")
  }

  const noRegi = () => {
    updateDoc(doc(db, "book-list", selectedGroup?.id), {
      users: arrayRemove({
        displayName: user?.displayName,
        phone: user?.phone,
        mail: user?.mail,
        age: user?.age,
        info: user?.info,
      }),
    }, { merge: true })

    updateDoc(doc(db, "book-list", selectedGroup?.id), {
      users: arrayUnion({
        displayName: user?.new_displayName ? user?.new_displayName : user?.displayName,
        phone: user?.new_phone ? user?.new_phone : user?.phone,
        mail: user?.new_mail ? user?.new_mail : user?.mail,
        age: user?.new_age ? user?.new_age : user?.age,
        info: user?.new_info ? user?.new_info : user?.info,
        registered: false,
      }),
    }, { merge: true })

    setUser("")
  }

  const deleteUser = () => {
    updateDoc(doc(db, "book-list", selectedGroup?.id), {
      users: arrayRemove({
        displayName: user?.displayName,
        phone: user?.phone,
        mail: user?.mail,
        age: user?.age,
        info: user?.info,
        registered: user?.registered
      }),
    }, { merge: true })

    setUser("")
    setConfDel("")
  }

  const weekDayConvert = (day) => {
    if (day === 1) return "Poniedziałek"
    if (day === 2) return "Wtorek"
    if (day === 3) return "Środa"
    if (day === 4) return "Czwartek"
    if (day === 5) return "Piątek"
    if (day === 6) return "Sobota"
    if (day === 7) return "Niedziela"
  }

  // dopasowanie w wyszukiwarce (po fragmencie)
  const matchSearch = (person) => {
    const q = searchQuery.trim().toLowerCase();
    if (!q) return true;

    const qDigits = normalizePhone(q);
    const name = normalizeName(person?.displayName);
    const email = normalizeEmail(person?.mail);
    const phone = normalizePhone(person?.phone);

    return (
      name.includes(q) ||
      email.includes(q) ||
      (qDigits ? phone.includes(qDigits) : false)
    );
  };

  const filteredUsers = Array.isArray(userList) ? userList.filter(matchSearch) : [];

  // ========= WYDARZENIA SPECJALNE: stan i logika =========
  const [specialEvents, setSpecialEvents] = useState([]);        // lista eventów
  const [selectedEvent, setSelectedEvent] = useState(null);      // wybrany event (definicja)
  const [eventList, setEventList] = useState(null);              // dokument special-list/{id}
  const [eventFormOpen, setEventFormOpen] = useState(false);     // modal dodawania eventu
  const [newEvent, setNewEvent] = useState({
    title: "",
    date: "",
    place: "",
    desc: "",
    color: "#0045C7",
    startTime: "",
    endTime: "",
    price: "",
    instructor: "",
    bannerUrl: "",
    slots: "",
    customId: ""
  });
  const [eventError, setEventError] = useState("");

  // helper: slug z tytułu
  const slugify = (s = "") =>
    s
      .toString()
      .normalize("NFKD")
      .replace(/[\u0300-\u036f]/g, "")
      .replace(/[^a-zA-Z0-9]+/g, "-")
      .replace(/^-+|-+$/g, "")
      .toLowerCase();

  // nasłuch listy eventów gdy wchodzimy do zakładki wydarzeń
  useEffect(() => {
    if (bookMark !== 2) return;
    const unsub = onSnapshot(collection(db, "special-events"), (snapshot) => {
      const evs = snapshot.docs.map(d => ({ id: d.id, ...d.data() }));
      // sort po dacie rosnąco, puste na koniec
      evs.sort((a,b) => (a.date||"9999-12-31").localeCompare(b.date||"9999-12-31"));
      setSpecialEvents(evs);
    });
    return () => unsub();
  }, [bookMark]);

  // po wybraniu eventu – nasłuch jego listy
  useEffect(() => {
    if (!selectedEvent?.id) return setEventList(null);
    const unsub = onSnapshot(doc(db, "special-list", selectedEvent.id), (snap) => {
      setEventList(snap.exists() ? snap.data() : { users: [], reserves: [] });
    });
    return () => unsub && unsub();
  }, [selectedEvent]);

  const openAddEvent = () => {
    setNewEvent({
      title: "",
      date: "",
      place: "",
      desc: "",
      color: "#0045C7",
      startTime: "",
      endTime: "",
      price: "",
      instructor: "",
      bannerUrl: "",
      slots: "",
      customId: ""
    });
    setEventError("");
    setEventFormOpen(true);
  };

  const saveNewEvent = async () => {
    setEventError("");
    const title = newEvent.title?.trim();
    const date = newEvent.date?.trim();

    if (!title || !date) {
      setEventError("Wymagane: tytuł i data.");
      return;
    }

    // id: customId lub slug(title) + '-' + date
    const baseId = newEvent.customId?.trim() || `${slugify(title)}-${date}`;
    const eventId = baseId.toLowerCase();

    const payload = {
      title,
      date,
      place: newEvent.place?.trim() || "",
      desc: newEvent.desc?.trim() || "",
      color: newEvent.color || "#0045C7",
      startTime: newEvent.startTime?.trim() || "",
      endTime: newEvent.endTime?.trim() || "",
      price: newEvent.price !== "" ? Number(newEvent.price) : "",
      instructor: newEvent.instructor?.trim() || "",
      bannerUrl: newEvent.bannerUrl?.trim() || "",
      slots: newEvent.slots !== "" ? Number(newEvent.slots) : ""
    };

    try {
      // 1) definicja wydarzenia
      await setDoc(doc(db, "special-events", eventId), payload, { merge: true });
      // 2) pusta lista
      await setDoc(doc(db, "special-list", eventId), { users: [], reserves: [] }, { merge: true });

      setEventFormOpen(false);
      // przenieś od razu do listy tego eventu:
      setSelectedEvent({ id: eventId, ...payload });
    } catch (e) {
      console.error(e);
      setEventError("Błąd podczas zapisu wydarzenia. Spróbuj ponownie.");
    }
  };

  // ===================== RENDER =====================
  return (
    <div style={({ display: "flex", gap: "40px", margin: "3%", width: "97%", marginTop: "20px" })}>
      {!facility ? (
        // EKRAN WYBORU: menu główne
        bookMark === 0 ? (
          <div style={({ display: "flex", gap: "40px", width: "100%", flexWrap: "wrap" })}>

            {/* KAFEL – LISTA UCZESTNIKÓW (global) */}
            <div
              style={({ display: "flex", gap: "12px", justifyContent: 'center', alignItems: "center", flexDirection: "column", padding: "30px", border: "1px solid rgb(30,30,30)", borderRadius: "5px", minWidth: 220, cursor: "pointer" })}
              onClick={() => setBookMark(1)}
            >
              <img style={({ width: "120px" })} src="users_icon.png" alt="" />
              <h3>Lista uczestników</h3>
            </div>

            {/* KAFEL – WYDARZENIA SPECJALNE (nowe) */}
            {/* <div
              style={({ display: "flex", gap: "12px", justifyContent: 'center', alignItems: "center", flexDirection: "column", padding: "30px", border: "1px solid rgb(30,30,30)", borderRadius: "5px", minWidth: 220, cursor: "pointer" })}
              onClick={() => { setBookMark(2); setSelectedEvent(null); }}
            >
              <img style={({ width: "120px" })} src="calendar_icon.png" alt="" />
              <h3>Wydarzenia specjalne</h3>
            </div> */}

            {/* Dotychczasowe kafle placówek */}
            {facilities
              ?.filter(
                (f) =>
                  f?.id !== "cfh66CW4jxFRMkU9AT5y" &&
                  f?.id !== "ExDQJ9bhXg5XUkiZta78"
              )
              ?.map((f) => (
                <div
                  key={f?.id}
                  style={{
                    display: "flex",
                    gap: "22px",
                    justifyContent: "center",
                    alignItems: "center",
                    flexDirection: "column",
                    padding: "30px",
                    border: "1px solid rgb(30,30,30)",
                    borderRadius: "5px",
                    minWidth: 220,
                    cursor: "pointer",
                  }}
                  onClick={() => setFacility(f)}
                >
                  <img
                    style={{ width: "120px" }}
                    src="logo_black.png"
                    alt=""
                  />

                  <h3>{f?.desc}</h3>
                </div>
              ))}
          </div>
        ) : bookMark === 1 ? (
          // WIDOK „LISTA UCZESTNIKÓW” (global)
          <div style={({ display: "flex", gap: "20px", width: "100%", flexDirection: "column" })}>
            <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
              <ArrowBack onClick={() => { setBookMark(0); setSearchQuery(""); }} />
              <h3 style={{ fontSize: 18, margin: 0 }}>Lista uczestników (globalnie)</h3>
            </div>

            <div style={{ display: "flex", alignItems: "center", gap: 20, flexWrap: "wrap" }}>
              <h3 style={{ margin: 0 }}>
                Unikalnych: <b>{globalCount.total}</b> &nbsp;|&nbsp; Zarejestrowanych: <b>{globalCount.registered}</b>
              </h3>
              <input
                placeholder="Szukaj: imię i nazwisko / e-mail / numer tel."
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                style={{ padding: "6px 10px", borderRadius: 6, border: "1px solid rgb(160,160,160)", minWidth: 320 }}
              />
            </div>

            <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
              {filteredUsers.length > 0 ? filteredUsers
                .sort((a, b) => (a.displayName || "").localeCompare(b.displayName || "", "pl"))
                .map((u, idx) => {
                  const groupIds = Array.from(new Set(u._groups || []));
                  const assignments = groupIds.map((gid) => {
                    const g = facilityGroupsMap[gid];
                    if (!g) return null;
                    const locName = locMap[g?.location_id]?.name || g?.location_id || "—";

                    let groupLabel = g?.type || "";
                    if (Array.isArray(g?.days)) {
                      const withCustom = g.days.find((d) => d?.custom_name);
                      if (withCustom?.custom_name) groupLabel = withCustom.custom_name;
                    } else if (g?.days?.custom_name) {
                      groupLabel = g.days.custom_name;
                    }

                    let times = "";
                    if (Array.isArray(g?.days)) {
                      times = g.days
                        .filter(Boolean)
                        .map((d) => `${dayAbbr(d.weekDay)} ${d.startTime}-${d.endTime}`)
                        .join(" • ");
                    } else if (g?.days) {
                      times = `${dayAbbr(g.days.weekDay)} ${g.days.startTime}-${g.days.endTime}`;
                    }

                    return { gid, locName, groupLabel, times };
                  }).filter(Boolean);

                  return (
                    <div key={idx} style={{ display: "flex", flexDirection: "column", gap: 4 }}>
                      <div style={{ display: "flex", alignItems: "center", gap: 10, flexWrap: "wrap" }}>
                        <h3 style={{ fontSize: 15, margin: 0 }}>
                          {idx + 1}. {u?.displayName || "(bez nazwy)"} &nbsp;–&nbsp; {u?.phone || "—"} &nbsp;–&nbsp; {u?.mail || "—"}
                        </h3>
                        {u?._occurrences > 1 && u?._canBeDuplicate && (
                          <span style={{ fontSize: 12, color: "#d0142d", fontWeight: "bold" }}>
                            (duplikat x{u._occurrences})
                          </span>
                        )}
                        {u?.registeredAny && <img src="checkMark.png" style={{ width: 16 }} alt="registered" />}
                      </div>

                      <div style={{ display: "flex", flexWrap: "wrap", gap: 6 }}>
                        {assignments.map((a) => (
                          <span
                            key={a.gid}
                            style={{
                              fontSize: 12,
                              border: "1px solid rgb(210,210,210)",
                              borderRadius: 6,
                              padding: "2px 8px",
                              background: "white",
                            }}
                            title={`Grupa: ${a.groupLabel}`}
                          >
                            {a.locName} — {a.groupLabel} — {a.times}
                          </span>
                        ))}
                      </div>
                    </div>
                  );
                })
                :
                <h3 style={{ fontSize: 15, color: "rgb(30,30,30)" }}>Brak wyników</h3>
              }
            </div>
          </div>
        ) : (
          // WIDOK „WYDARZENIA SPECJALNE”
          <div style={{ display: "flex", flexDirection: "column", gap: 16, width: "100%" }}>
            <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
              <ArrowBack onClick={() => { setBookMark(0); setSelectedEvent(null); }} />
              <h3 style={{ fontSize: 18, margin: 0 }}>Wydarzenia specjalne</h3>
            </div>

            {!selectedEvent ? (
              <>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: 10 }}>
                  <h3 style={{ margin: 0, fontSize: 16, color: "#333" }}>
                    Wybierz wydarzenie, aby przejść od razu do listy zapisów.
                  </h3>
                  <button
                    onClick={openAddEvent}
                    style={{ padding: "8px 12px", borderRadius: 8, border: "1px solid #0045C7", background: "#0045C7", color: "white", fontWeight: 700, cursor: "pointer" }}
                  >
                    Dodaj wydarzenie
                  </button>
                </div>

                <div style={{ display: "flex", flexWrap: "wrap", gap: 12 }}>
                  {specialEvents.length > 0 ? specialEvents.map(ev => (
                    <div
                      key={ev.id}
                      onClick={() => setSelectedEvent(ev)}
                      style={{
                        border: "1px solid rgba(0,0,0,.2)",
                        borderRadius: 8,
                        padding: 12,
                        minWidth: 240,
                        cursor: "pointer",
                        background: "#fff"
                      }}
                    >
                      <h4 style={{ margin: 0, fontSize: 16, color: ev.color || "#0045C7" }}>{ev.title}</h4>
                      <div style={{ fontSize: 12, color: "#555", marginTop: 4 }}>
                        {ev.date}{(ev.startTime || ev.endTime) ? ` • ${ev.startTime || ""}${ev.startTime && ev.endTime ? "-" : ""}${ev.endTime || ""}` : ""}
                      </div>
                      {ev.place && <div style={{ fontSize: 12, color: "#666" }}>{ev.place}</div>}
                    </div>
                  )) : (
                    <h3 style={{ fontSize: 14, color: "#444" }}>Brak wydarzeń — dodaj pierwsze.</h3>
                  )}
                </div>
              </>
            ) : (
              // LISTA ZAPISÓW DLA WYBRANEGO EVENTU
              <div style={{ display: "flex", gap: 24, alignItems: "flex-start", width: "100%", flexWrap: "wrap" }}>
                <div style={{ minWidth: 280 }}>
                  <button
                    onClick={() => setSelectedEvent(null)}
                    style={{ padding: "6px 10px", borderRadius: 8, border: "1px solid #ccc", background: "#fff", cursor: "pointer", marginBottom: 12 }}
                  >
                    ← Wróć do listy wydarzeń
                  </button>
                  <h3 style={{ margin: "4px 0", fontSize: 18, color: selectedEvent.color || "#0045C7" }}>{selectedEvent.title}</h3>
                  <div style={{ fontSize: 13, color: "#333" }}>
                    {selectedEvent.date}{(selectedEvent.startTime || selectedEvent.endTime) ? ` • ${selectedEvent.startTime || ""}${selectedEvent.startTime && selectedEvent.endTime ? "-" : ""}${selectedEvent.endTime || ""}` : ""}
                  </div>
                  {selectedEvent.place && <div style={{ fontSize: 13, color: "#444" }}>{selectedEvent.place}</div>}
                  {selectedEvent.price !== "" && <div style={{ fontSize: 13, color: "#444" }}>Cena: {selectedEvent.price} zł</div>}
                  {selectedEvent.instructor && <div style={{ fontSize: 13, color: "#444" }}>Instruktor: {selectedEvent.instructor}</div>}
                  {selectedEvent.slots !== "" && <div style={{ fontSize: 13, color: "#444" }}>Limit miejsc: {selectedEvent.slots}</div>}
                  {selectedEvent.desc && <p style={{ fontSize: 13, color: "#333", marginTop: 10 }}>{selectedEvent.desc}</p>}
                </div>

                <div style={{ flex: 1, minWidth: 320 }}>
                  <h4 style={{ margin: 0, fontSize: 16 }}>Lista zapisanych</h4>
                  {eventList?.users?.length > 0 ? eventList.users.map((u, i) => (
                    <div key={i} style={{ padding: "6px 0", borderBottom: "1px dashed rgba(0,0,0,.1)" }}>
                      <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                        <strong style={{ fontSize: 14 }}>{i + 1}. {u?.displayName || "(bez nazwy)"}</strong>
                        {u?.registered ? <img src="checkMark.png" alt="" style={{ width: 16 }} /> : <img src="close.png" alt="" style={{ width: 16 }} />}
                      </div>
                      <div style={{ fontSize: 12, color: "#444" }}>
                        tel: {u?.phone || "—"} • mail: {u?.mail || "—"}
                      </div>
                      {u?.info && <div style={{ fontSize: 12, color: "#666" }}>Info: {u?.info}</div>}
                    </div>
                  )) : (
                    <div style={{ fontSize: 14, color: "#444", marginTop: 6 }}>Brak zapisanych</div>
                  )}

                  {eventList?.reserves?.length > 0 && (
                    <>
                      <h4 style={{ marginTop: 16, fontSize: 16 }}>Rezerwowi</h4>
                      {eventList.reserves.map((r, i) => (
                        <div key={i} style={{ fontSize: 14, color: "#333" }}>
                          {i + 1}. {r?.displayName || "(bez nazwy)"}
                        </div>
                      ))}
                    </>
                  )}
                </div>
              </div>
            )}

            {/* MODAL DODAWANIA WYDARZENIA */}
            {eventFormOpen && (
              <div
                onClick={() => setEventFormOpen(false)}
                style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,.45)", display: "grid", placeItems: "center", zIndex: 5000 }}
              >
                <div
                  onClick={(e) => e.stopPropagation()}
                  style={{ width: "min(720px, 94vw)", background: "#fff", borderRadius: 12, padding: 16, boxShadow: "0 20px 40px rgba(0,0,0,.35)" }}
                >
                  <h3 style={{ margin: "0 0 8px 0" }}>Dodaj wydarzenie</h3>
                  <p style={{ margin: "4px 0 14px 0", fontSize: 12, color: "#555" }}>
                    Wymagane: <b>tytuł</b> i <b>data</b>. ID wydarzenia powstanie z tytułu+daty (możesz nadpisać).
                  </p>

                  <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12 }}>
                    <label style={{ fontSize: 12 }}>
                      Tytuł*<br />
                      <input
                        value={newEvent.title}
                        onChange={(e) => setNewEvent(v => ({ ...v, title: e.target.value }))}
                        style={{ width: "100%", padding: "8px", borderRadius: 8, border: "1px solid #ccc" }}
                      />
                    </label>
                    <label style={{ fontSize: 12 }}>
                      Data* (YYYY-MM-DD)<br />
                      <input
                        value={newEvent.date}
                        onChange={(e) => setNewEvent(v => ({ ...v, date: e.target.value }))}
                        placeholder="2025-11-22"
                        style={{ width: "100%", padding: "8px", borderRadius: 8, border: "1px solid #ccc" }}
                      />
                    </label>

                    <label style={{ fontSize: 12 }}>
                      Start (opcjonalnie)<br />
                      <input
                        value={newEvent.startTime}
                        onChange={(e) => setNewEvent(v => ({ ...v, startTime: e.target.value }))}
                        placeholder="10:00"
                        style={{ width: "100%", padding: "8px", borderRadius: 8, border: "1px solid #ccc" }}
                      />
                    </label>
                    <label style={{ fontSize: 12 }}>
                      Koniec (opcjonalnie)<br />
                      <input
                        value={newEvent.endTime}
                        onChange={(e) => setNewEvent(v => ({ ...v, endTime: e.target.value }))}
                        placeholder="13:00"
                        style={{ width: "100%", padding: "8px", borderRadius: 8, border: "1px solid #ccc" }}
                      />
                    </label>

                    <label style={{ fontSize: 12 }}>
                      Miejsce (opcjonalnie)<br />
                      <input
                        value={newEvent.place}
                        onChange={(e) => setNewEvent(v => ({ ...v, place: e.target.value }))}
                        placeholder="Wrocław, Sala A"
                        style={{ width: "100%", padding: "8px", borderRadius: 8, border: "1px solid #ccc" }}
                      />
                    </label>
                    <label style={{ fontSize: 12 }}>
                      Cena (opcjonalnie)<br />
                      <input
                        value={newEvent.price}
                        onChange={(e) => setNewEvent(v => ({ ...v, price: e.target.value }))}
                        placeholder="120"
                        type="number"
                        min="0"
                        style={{ width: "100%", padding: "8px", borderRadius: 8, border: "1px solid #ccc" }}
                      />
                    </label>

                    <label style={{ fontSize: 12 }}>
                      Instruktor (opcjonalnie)<br />
                      <input
                        value={newEvent.instructor}
                        onChange={(e) => setNewEvent(v => ({ ...v, instructor: e.target.value }))}
                        placeholder="Jan Kowalski"
                        style={{ width: "100%", padding: "8px", borderRadius: 8, border: "1px solid #ccc" }}
                      />
                    </label>
                    <label style={{ fontSize: 12 }}>
                      Limit miejsc (opcjonalnie)<br />
                      <input
                        value={newEvent.slots}
                        onChange={(e) => setNewEvent(v => ({ ...v, slots: e.target.value }))}
                        placeholder="40"
                        type="number"
                        min="0"
                        style={{ width: "100%", padding: "8px", borderRadius: 8, border: "1px solid #ccc" }}
                      />
                    </label>

                    <label style={{ gridColumn: "1 / span 2", fontSize: 12 }}>
                      Opis (opcjonalnie)<br />
                      <textarea
                        value={newEvent.desc}
                        onChange={(e) => setNewEvent(v => ({ ...v, desc: e.target.value }))}
                        rows={3}
                        style={{ width: "100%", padding: "8px", borderRadius: 8, border: "1px solid #ccc", resize: "vertical" }}
                      />
                    </label>

                    <label style={{ fontSize: 12 }}>
                      Kolor (opcjonalnie)<br />
                      <input
                        value={newEvent.color}
                        onChange={(e) => setNewEvent(v => ({ ...v, color: e.target.value }))}
                        placeholder="#0045C7"
                        style={{ width: "100%", padding: "8px", borderRadius: 8, border: "1px solid #ccc" }}
                      />
                    </label>
                    <label style={{ fontSize: 12 }}>
                      Baner URL (opcjonalnie)<br />
                      <input
                        value={newEvent.bannerUrl}
                        onChange={(e) => setNewEvent(v => ({ ...v, bannerUrl: e.target.value }))}
                        placeholder="https://.../plakat.jpg"
                        style={{ width: "100%", padding: "8px", borderRadius: 8, border: "1px solid #ccc" }}
                      />
                    </label>

                    <label style={{ gridColumn: "1 / span 2", fontSize: 12 }}>
                      ID wydarzenia (opcjonalnie – nadpisze automatyczne)<br />
                      <input
                        value={newEvent.customId}
                        onChange={(e) => setNewEvent(v => ({ ...v, customId: e.target.value }))}
                        placeholder="np. warsztaty-hiphop-2025-11-22"
                        style={{ width: "100%", padding: "8px", borderRadius: 8, border: "1px solid #ccc" }}
                      />
                    </label>
                  </div>

                  {eventError && <div style={{ color: "#c71e32", fontSize: 12, marginTop: 8 }}>{eventError}</div>}

                  <div style={{ display: "flex", justifyContent: "flex-end", gap: 8, marginTop: 14 }}>
                    <button
                      onClick={() => setEventFormOpen(false)}
                      style={{ padding: "8px 12px", borderRadius: 8, border: "1px solid #bbb", background: "#fff", cursor: "pointer" }}
                    >
                      Anuluj
                    </button>
                    <button
                      onClick={saveNewEvent}
                      style={{ padding: "8px 12px", borderRadius: 8, border: "1px solid #0045C7", background: "#0045C7", color: "#fff", fontWeight: 800, cursor: "pointer" }}
                    >
                      Zapisz wydarzenie
                    </button>
                  </div>
                </div>
              </div>
            )}
          </div>
        )
      ) : (
        // ======= DOTYCHCZASOWE WIDOKI: wybór lokalizacji → grupy → lista =========
        !location ? (
          <div style={({display: "flex", justifyContent: "flex-start", alignItems: "flex-start", flexWrap: "wrap", width: "95%", gap: "20px"})}>
            <ArrowBack onClick={() => setFacility("")}/>
            {locations &&
              Object?.values(locations)?.sort((a, b) => a.name.localeCompare(b.name))?.map((l) =>
                l?.jbie === true &&
                <h3 key={l?.id} onClick={() => setLocation(l)} style={({background: l?.color, borderRadius: "5px", padding: "10px 20px", color: "rgb(250,250,250)"})}>{l?.name}</h3>
              )}
            {locations &&
              Object?.values(locations)?.sort((a, b) => a.name.localeCompare(b.name))?.map((l) =>
                !l.jbie &&
                <h3 key={l?.id} onClick={() => setLocation(l)} style={({background: l?.color, borderRadius: "5px", padding: "10px 20px", color: "rgb(250,250,250)"})}>{l?.name}</h3>
              )}
          </div>
        ) : groups && !selectedGroup ? (
          <div style={({display: "flex", gap: "17px", justifyContent: 'flex-start', alignItems: "flex-start", flexDirection: "column", width: "100%"})}>
            <h3 style={({fontSize: "22px", color: location?.color})}>{location?.name}</h3>
            <div style={({display: "flex", gap: "26px", justifyContent: 'flex-start', alignItems: "flex-start", flexDirection: "row", width: "100%"})}>
              <ArrowBack onClick={() => setLocation("")}/>
              {[1,2,3,4,5,6].map(weekday =>
                Object?.values(groups)?.filter(x => x?.location_id === location?.id)?.filter(x => x?.days?.weekDay === weekday)?.length > 0 && (
                  <div key={weekday} style={({display: "flex", gap: "12px", justifyContent: 'flex-start', alignItems: "center", flexDirection: "column", width: "14%"})}>
                    <h3 style={({fontSize: "13px", color: "#f5f5f5", background: location?.color, padding: "10px", width: "100%", borderRadius: '5px', textAlign: "center"})}>
                      {weekDayConvert(weekday)?.toUpperCase()}
                    </h3>
                    {Object?.values(groups)
                      ?.filter(x => x?.location_id === location?.id)
                      ?.filter(x => x?.days?.weekDay === weekday)
                      ?.sort((a, b) => {
                        const timeA = a?.days?.startTime.split(':').map(Number);
                        const timeB = b?.days?.startTime.split(':').map(Number);
                        return timeA[0] - timeB[0] || timeA[1] - timeB[1];
                      })
                      ?.map((g) =>
                        <div key={`${g?.id}-${g?.days?.startTime}`}
                          style={({display: "flex", gap: "5px", justifyContent: 'space-around', alignItems: "center", flexDirection: "column", width: "90%", padding: "10%", borderRadius: "5px", border: "1px solid rgb(40,40,40)", height: "100px"})}
                          onClick={() => setSelectedGroup(g)}
                        >
                          <h3 style={({fontSize: "14px", color: "rgb(40,40,40)"})}>{g?.days?.startTime} - {g?.days?.endTime}</h3>
                          <h3 style={({fontSize: "14px", color: location?.color, textAlign: "center"})}>{g?.days?.custom_name ? g?.days?.custom_name : g?.type}</h3>
                          <h3 style={({fontSize: "12px", color: "rgb(40,40,40)"})}>{g?.maxAge === 99 ? (g?.adults ? `Dorośli ${g?.minAge} +` : `${g?.minAge} +`) : `${g?.minAge} - ${g?.maxAge} lat`}</h3>
                          <h3 style={({fontSize: "10px", color: "rgb(40,40,40)", textAlign: "center"})}>{g?.exp}</h3>
                        </div>
                      )}
                  </div>
                )
              )}
            </div>
            <div style={({width: "100%", marginTop: "14px", display: "flex", justifyContent: "flex-start"})}>
              <h3 style={({fontSize: "14px", color: "rgb(30,30,30)"})}>
                Łącznie zapisanych w tej lokalizacji:&nbsp;
                <span style={{ color: location?.color, fontWeight: "bold" }}>{locCount.total}</span>
              </h3>
            </div>
          </div>
        ) : (
          // widok pojedynczej grupy i lista
          <div style={({display: "flex", gap: "32px", justifyContent: 'space-between', alignItems: "flex-start", flexDirection: "row", width: "85%", marginLeft: "10px"})}>
            <div style={({display: "flex", gap: "5px", justifyContent: 'flex-start', alignItems: "flex-start", flexDirection: "column"})}>
              <ArrowBack onClick={() => {setList(""); setSelectedGroup("")}}/>
              <h3 style={({fontSize: "18px", color: location?.color})}>{location?.name} - {selectedGroup?.days?.custom_name ? selectedGroup?.days?.custom_name : selectedGroup?.type}</h3>
              <h3 style={({fontSize: "16px", color: "rgb(30,30,30)", marginTop: "3px"})}>{weekDayConvert(selectedGroup?.days?.weekDay)} {selectedGroup?.days?.startTime} - {selectedGroup?.days?.endTime}</h3>
              <h3 style={({fontSize: "14px", color: "rgb(30,30,30)", marginTop: "15px"})}>Poziom: {selectedGroup?.exp}</h3>
              <h3 style={({fontSize: "14px", color: "rgb(30,30,30)", marginTop: "15px"})}>Grupa wiekowa: {selectedGroup?.maxAge === 99 ? (selectedGroup?.adults ? `Dorośli ${selectedGroup?.minAge} +` : `${selectedGroup?.minAge} +`) : `${selectedGroup?.minAge} - ${selectedGroup?.maxAge} lat`}</h3>
              <h3 style={({fontSize: "14px", color: "rgb(30,30,30)", marginTop: "15px"})}>Instruktor: {selectedGroup?.instructor ? selectedGroup?.instructor : "Nie podano"}</h3>
              <h3 style={({fontSize: "14px", color: "rgb(30,30,30)", marginTop: "15px"})}>Data startu grupy: {selectedGroup?.startDate ? selectedGroup?.startDate : "Nie podano"}</h3>
              <h3 style={({fontSize: "18px", color: location?.color, marginTop: "25px"})}>Cennik:</h3>
              {!selectedGroup?.allSeason && <h3 style={({fontSize: "15px", color: "rgb(30,30,30)", marginTop: "5px"})}>Umowa z wypowiedzeniem miesięcznym: {selectedGroup?.prices?.contract} zł</h3>}
              <h3 style={({fontSize: "15px", color: "rgb(30,30,30)", marginTop: "5px"})}>Wejście jednorazowe: {selectedGroup?.prices?.entry} zł</h3>
              {selectedGroup?.allSeason === true && <h3 style={({fontSize: "15px", color: "rgb(30,30,30)", marginTop: "5px"})}>Umowa bez możliwości wypowiedzenia na rok szkolny: {selectedGroup?.prices?.contract + " zł"}</h3>}
              <h3 style={({fontSize: "14px", color: "rgb(30,30,30)", marginTop: "35px"})}>Okres wypowiedzenia umowy: {selectedGroup?.adults ? "Koniec danego miesiąca" : "Miesiąc"}</h3>
              <h3 style={({fontSize: "14px", color: location?.color, marginTop: "15px"})}>Dodatkowy opis grupy: {selectedGroup?.desc ? selectedGroup?.desc  : "Nie podano"}</h3>
            </div>
            <div style={({display: "flex", gap: "5px", justifyContent: 'flex-start', alignItems: "flex-start", flexDirection: "column"})}>
              <h3 style={({fontSize: "16px", color: location?.color})}>Maksymalna ilość miejsc: {selectedGroup?.slots}</h3>
              <h3 style={({fontSize: "18px", color: "rgb(30,30,30)", marginTop: "5px"})}>Lista:</h3>
              {list?.users?.length > 0 ?
                list?.users?.map((u, index) =>
                  <div key={`${u?.displayName}-${index}`} style={({display: "flex", justifyContent: 'flex-start', alignItems: "flex-start", flexDirection: "column"})} onClick={() => setUser(u)}>
                    <div style={({display: "flex", justifyContent: 'flex-start', alignItems: "center", flexDirection: "row", gap: "7px"})}>
                      <h3 style={({fontSize: "15px", color: "rgb(30,30,30)", marginTop: "5px"})}>{index + 1}. {u?.displayName} {u?.age && u?.age !== " " ? "- " + u?.age + " lat" : ""}</h3>
                      {u?.registered && <img src="checkMark.png" style={({width: "17px", marginTop: "5px"})} alt="" />}
                      {u?.registered === false && <img src="close.png" style={({width: "17px", marginTop: "5px"})} alt="" />}
                    </div>
                    <h3 style={({fontSize: "13px", color: "rgb(30,30,30)", fontWeight: "normal", marginLeft: "15px"})}>tel: {u?.phone} - mail: {u?.mail}</h3>
                    {(u?.info && u?.info !== " ") && <h3 style={({fontSize: "13px", color: "rgb(30,30,30)", fontWeight: "normal", marginLeft: "15px", maxWidth: "200px"})}>Dodatkowe informacje: {u?.info}</h3>}
                  </div>
                )
              :
                <h3 style={({fontSize: "15px", color: "rgb(30,30,30)", marginTop: "5px"})}>Brak uczestników</h3>
              }
              {list?.users?.length < selectedGroup?.slots && <button onClick={() => setNewUser({active: true})} style={({padding: "6px 12px", backgroundColor: location?.color, border: "none", outline: "none", borderRadius: "5px", fontWeight: "bold", color: "rgb(245,245,245)", marginTop: "20px", fontSize: "12px"})}>Dodaj uczestnika do listy</button>}
              {list?.reserves?.length > 0 && <h3>Rezerwowi:</h3>}
              {list?.reserves?.length > 0 && list?.reserves?.map((r, index) =>
                <h3 key={`${r?.displayName}-${index}`} onClick={() => setUser(r)}>{index + 1}. {r?.displayName}</h3>
              )}
            </div>
          </div>
        )
      )}

      {/* MODAL: Dodaj nową osobę do listy (grupy) */}
      {newUser &&
        <div style={({display: "flex", justifyContent: 'flex-start', alignItems: "center", flexDirection: "column", width: "100%", backgroundColor: "rgb(30,30,30,0.5)", position: "fixed", top: "0px", left: "0px", height: "100vh"})}>
          <div style={({display: "flex", gap: "15px", justifyContent: 'flex-start', alignItems: "flex-start", flexDirection: "column", backgroundColor: "rgb(245,245,245)", padding: "30px", border: "2px solid rgb(30,30,30)", borderRadius: "5px", marginTop: "6%"})}>
            <h3 style={({fontSize: "18px", color: "rgb(30,30,30)", marginTop: "-10px"})}>Dodaj użytkownika na listę</h3>
            <div style={({display: "flex", gap: "10px", justifyContent: 'flex-start', alignItems: "flex-start", flexDirection: "row", marginTop: "7px"})}>
              <h3 style={({fontSize: "15px", color: "rgb(30,30,30)", width: "120px"})}>Imię i nazwisko</h3>
              <input onBlur={(e) => setNewUser({...newUser, displayName: e?.target?.value})} style={({borderRadius: "5px", outline: "none", border: `1px solid rgb(30,30,30)`})}/>
            </div>
            <div style={({display: "flex", gap: "10px", justifyContent: 'flex-start', alignItems: "flex-start", flexDirection: "row", marginTop: "3px"})}>
              <h3 style={({fontSize: "15px", color: "rgb(30,30,30)", width: "120px"})}>Numer telefonu</h3>
              <input onBlur={(e) => setNewUser({...newUser, phone: e?.target?.value})} style={({borderRadius: "5px", outline: "none", border: `1px solid rgb(30,30,30)`})}/>
            </div>
            <div style={({display: "flex", gap: "10px", justifyContent: 'flex-start', alignItems: "flex-start", flexDirection: "row", marginTop: "3px"})}>
              <h3 style={({fontSize: "15px", color: "rgb(30,30,30)", width: "120px"})}>Adres email</h3>
              <input onBlur={(e) => setNewUser({...newUser, mail: e?.target?.value})} style={({borderRadius: "5px", outline: "none", border: `1px solid rgb(30,30,30)`})}/>
            </div>
            <div style={({display: "flex", gap: "10px", justifyContent: 'flex-start', alignItems: "flex-start", flexDirection: "row", marginTop: "3px"})}>
              <h3 style={({fontSize: "15px", color: "rgb(30,30,30)", width: "120px"})}>Wiek (opcjonalnie)</h3>
              <input onBlur={(e) => setNewUser({...newUser, age: e?.target?.value})} style={({borderRadius: "5px", outline: "none", border: `1px solid rgb(30,30,30)`})}/>
            </div>
            <div style={({display: "flex", gap: "10px", justifyContent: 'flex-start', alignItems: "flex-start", flexDirection: "row", marginTop: "3px"})}>
              <h3 style={({fontSize: "13px", color: "rgb(30,30,30)", width: "160px"})}>Dodatkowe informacje (opcj.)</h3>
              <input onBlur={(e) => setNewUser({...newUser, info: e?.target?.value})} style={({borderRadius: "5px", outline: "none", border: `1px solid rgb(30,30,30)`})}/>
            </div>
            <div style={({display: "flex", justifyContent: 'flex-start', alignItems: "flex-start", flexDirection: "row", marginTop: "3px", width: "100%"})}>
              <button onClick={() => addUser()} style={({width: "80%", height: "30px", backgroundColor: location?.color, border: "none", outline: "none", borderRadius: "5px", fontWeight: "bold", color: "rgb(245,245,245)"})}>DODAJ UŻYTKOWNIKA</button>
              <button onClick={() => {setNewUser(""); setError("")}} style={({width: "20%", height: "30px", border: "none", outline: "none", borderRadius: "5px", fontWeight: "bold", backgroundColor: "rgb(245,245,245)"})}>ANULUJ</button>
            </div>
            {error && <h3 style={({fontSize: "13px", color: "#c71e32"})}>{error}</h3>}
          </div>
        </div>
      }

      {/* MODAL: Edycja/akceptacja/usuń (grupy) */}
      {user &&
        <div style={({display: "flex", justifyContent: 'flex-start', alignItems: "center", flexDirection: "column", width: "100%", backgroundColor: "rgb(30,30,30,0.5)", position: "fixed", top: "0px", left: "0px", height: "100vh"})}>
          <div style={({display: "flex", gap: "15px", justifyContent: 'flex-start', alignItems: "flex-start", flexDirection: "column", backgroundColor: "rgb(245,245,245)", padding: "30px", border: "2px solid rgb(30,30,30)", borderRadius: "5px", marginTop: "6%"})}>
            <h3 style={({fontSize: "18px", color: "rgb(30,30,30)", marginTop: "-10px"})}>Edytuj użytkownika</h3>
            <div style={({display: "flex", gap: "10px", justifyContent: 'flex-start', alignItems: "flex-start", flexDirection: "row", marginTop: "7px"})}>
              <h3 style={({fontSize: "15px", color: "rgb(30,30,30)", width: "120px"})}>Imię i nazwisko</h3>
              <input onBlur={(e) => setUser({...user, new_displayName: e?.target?.value})} style={({borderRadius: "5px", outline: "none", border: `1px solid rgb(30,30,30)`})} defaultValue={user?.displayName}/>
            </div>
            <div style={({display: "flex", gap: "10px", justifyContent: 'flex-start', alignItems: "flex-start", flexDirection: "row", marginTop: "3px"})}>
              <h3 style={({fontSize: "15px", color: "rgb(30,30,30)", width: "120px"})}>Numer telefonu</h3>
              <input onBlur={(e) => setUser({...user, new_phone: e?.target?.value})} style={({borderRadius: "5px", outline: "none", border: `1px solid rgb(30,30,30)`})} defaultValue={user?.phone}/>
            </div>
            <div style={({display: "flex", gap: "10px", justifyContent: 'flex-start', alignItems: "flex-start", flexDirection: "row", marginTop: "3px"})}>
              <h3 style={({fontSize: "15px", color: "rgb(30,30,30)", width: "120px"})}>Adres email</h3>
              <input onBlur={(e) => setUser({...user, new_mail: e?.target?.value})} style={({borderRadius: "5px", outline: "none", border: `1px solid rgb(30,30,30)`})} defaultValue={user?.mail}/>
            </div>
            <div style={({display: "flex", gap: "10px", justifyContent: 'flex-start', alignItems: "flex-start", flexDirection: "row", marginTop: "3px"})}>
              <h3 style={({fontSize: "15px", color: "rgb(30,30,30)", width: "120px"})}>Wiek (opcjonalnie)</h3>
              <input onBlur={(e) => setUser({...user, new_age: e?.target?.value})} style={({borderRadius: "5px", outline: "none", border: `1px solid rgb(30,30,30)`})} defaultValue={user?.age}/>
            </div>
            <div style={({display: "flex", gap: "10px", justifyContent: 'flex-start', alignItems: "flex-start", flexDirection: "row", marginTop: "3px"})}>
              <h3 style={({fontSize: "13px", color: "rgb(30,30,30)", width: "160px"})}>Dodatkowe informacje (opcj.)</h3>
              <input onBlur={(e) => setUser({...user, new_info: e?.target?.value})} style={({borderRadius: "5px", outline: "none", border: `1px solid rgb(30,30,30)`})} defaultValue={user?.info}/>
            </div>
            <div style={({display: "flex", justifyContent: 'flex-start', alignItems: "flex-start", flexDirection: "row", marginTop: "3px", width: "100%"})}>
              <button onClick={() => editUser()} style={({width: "50%", height: "30px", backgroundColor: location?.color, border: "none", outline: "none", borderRadius: "5px", fontWeight: "bold", color: "rgb(245,245,245)"})}>ZATWIERDŹ ZMIANY</button>
              <button onClick={() => {setUser(""); setError("")}} style={({width: "20%", height: "30px", border: "none", outline: "none", borderRadius: "5px", fontWeight: "bold", backgroundColor: "rgb(245,245,245)"})}>ANULUJ</button>
              <button onClick={() => setConfDel(true)} style={({width: "30%", height: "30px", border: "none", outline: "none", borderRadius: "5px", fontWeight: "bold", backgroundColor: "rgb(245,245,245)"})}>USUŃ Z LISTY</button>
              <button onClick={() => confirmUser()} style={({width: "30%", height: "30px", border: "none", outline: "none", borderRadius: "5px", fontWeight: "bold", backgroundColor: "rgb(245,245,245)"})}>ZAREJESTROWANY</button>
            </div>
            {error && <h3 style={({fontSize: "13px", color: "#c71e32"})}>{error}</h3>}
          </div>
        </div>
      }

      {/* MODAL: potwierdzenie usunięcia z listy (grupy) */}
      {confDel &&
        <div style={({display: "flex", justifyContent: 'flex-start', alignItems: "center", flexDirection: "column", width: "100%", backgroundColor: "rgb(30,30,30,0.5)", position: "fixed", top: "0px", left: "0px", height: "100vh"})}>
          <div style={({display: "flex", gap: "15px", justifyContent: 'center', alignItems: "center", flexDirection: "column", backgroundColor: "rgb(245,245,245)", padding: "30px", border: "2px solid rgb(30,30,30)", borderRadius: "5px", marginTop: "6%", width: "400px", height: "250px"})}>
            <h3 style={({fontSize: "18px", color: "rgb(30,30,30)"})}>Czy na pewno chcesz usunąć użytkownika?</h3>
            <div style={({display: "flex", gap: "10px", justifyContent: 'flex-start', alignItems: "flex-start", flexDirection: "row", marginTop: "7px"})}>
              <h3 style={({fontSize: "20px", color: "rgb(30,30,30)"})}>{user?.displayName}</h3>
            </div>
            <div style={({display: "flex", justifyContent: 'space-around', alignItems: "center", flexDirection: "row", marginTop: "3px", width: "100%"})}>
              <button style={({fontSize: "13px", color: "white", borderRadius: "5px", marginTop: "10px", backgroundColor: "#0045C7", border: "2px solid #0045C7", transition: "0.7s", fontWeight: "bold", padding: "10px 20px", width: "150px"})} onClick={() => {setConfDel("")}} >ANULUJ</button>
              <button style={({fontSize: "13px", color: "white", borderRadius: "5px", marginTop: "10px", backgroundColor: "#bd203f", border: "2px solid #bd203f", transition: "0.7s", fontWeight: "bold", padding: "10px 20px", width: "200px"})} onClick={() => deleteUser()} >USUŃ Z LISTY</button>
            </div>
            {error && <h3 style={({fontSize: "13px", color: "#c71e32"})}>{error}</h3>}
          </div>
        </div>
      }
    </div>
  );
}
